import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import FormikTextField from '../../shared/components/formik/FormikTextField'
import useTeamsResources from '../../shared/resources/api/v1/admin/useTeamsResources'
import { useTeams } from '../../contexts/TeamsContext'
import PageBreadcrumbs from '../../shared/components/PageBreadcrumbs'

function CreateTeam() {
  const intl = useIntl()
  const navigate = useNavigate()
  const { create } = useTeamsResources()
  const { loadTeams } = useTeams()

  const validationSchema = Yup.object({
    name: Yup.string().required(intl.formatMessage({ id: 'login.error.required' })),
    slug: Yup.string(),
  })

  const formik = useFormik({
    initialValues: {
      name: '',
      slug: '',
    },
    validationSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      const teamData = { team: { name: values.name } }
      if (values.slug) {
        teamData.team.slug = values.slug
      }

      create(teamData)
        .then(() => {
          return loadTeams()
        })
        .then(() => {
          navigate('/')
        })
        .catch((err) => {
          setStatus(err.message || 'Error creating team')
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
  })

  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4 }}>
        <PageBreadcrumbs />
        <Typography variant="h4" component="h1" gutterBottom>
          <FormattedMessage id="teams.create.title" />
        </Typography>

        <Box component="form" onSubmit={formik.handleSubmit}>
          <FormikTextField
            formik={formik}
            name="name"
            label={<FormattedMessage id="teams.create.nameLabel" />}
            autoFocus
          />

          <Box sx={{ mt: 2 }}>
            <FormikTextField
              formik={formik}
              name="slug"
              label={<FormattedMessage id="teams.create.slugLabel" />}
            />
          </Box>

          {formik.status && (
            <Typography color="error" sx={{ mt: 2 }}>
              {formik.status}
            </Typography>
          )}

          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={formik.isSubmitting}
            sx={{ mt: 3 }}
          >
            <FormattedMessage id="teams.create.submitButton" />
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default CreateTeam
